<section id="contact">
    <div class="box-white">
        <div class="wrapper padding-all">
            <div class="row">
                <div class="col-md-5 col-sm-12">
                    <div class="">
                        <div class="table-responsive">
                            <table id="example1" class="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>S.N.</th>
                                        <th>Title </th>
                                        <th>Description</th>
                                        <!-- <th>Status</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let user of dataNews; let i=index">
                                        <td>{{i+1}}</td>
                                        <td><span style="white-space: pre-wrap">{{user.nmpk_newsTitle}}</span> </td>
                                        <td><span style="white-space: pre-wrap">{{user.nmpk_newsDesc.slice(0,50)}}...</span>
                                            <br> <a href="javascript:void(0)" (click)="NewsById(user.nmpk_newsId)" class="text-info">Read More</a>
                                        </td>
                                        <!-- <td>
                                            {{user.nmpk_newsStatus}}
                                        </td> -->

                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
                <div class="col-md-7 col-sm-12">
                    <div class="box-custom padding-all-20 center">
                        <h2>संपूर्ण बातमी</h2>
                    </div>
                    <div class="box-grey padding-all-20" *ngIf="news">
                        <h3>{{news.nmpk_newsTitle}}</h3>
                        <p style="white-space: pre-wrap">{{news.nmpk_newsDesc}}</p>

                        <div *ngIf="news.nmpk_newsUpload !=''" >
                            <a href="https://nmpksbank.in/apis/{{news.nmpk_newsUpload}}" target="_blank" class="text-success"><i class="fa fa-download" aria-hidden="true"></i> {{news.nmpk_newsUpload}}</a>
                        </div>
                        <div>Publish Date</div>{{news.nmpk_newsPublishDate}} </div>
                </div>
            </div>
        </div>
    </div>
</section>
